
<template>
  <div class="new-box">
    <Table :columns="columns10" :data="data9">
      <template slot-scope="{ row }" slot="name">
        <strong>{{ row.name }}</strong>
      </template>
      <template slot-scope="{ row }" slot="type">{{ row.type }}</template>
      <template slot-scope="{ row }" slot="content">{{ row.content }}</template>
      <template slot-scope="{ row }" slot="time">{{ row.time }}</template>
      <template slot-scope="{ row }" slot="status">
        <span v-if="row.status === 0" style="color: #1890ff;">已通过</span>
        <span v-if="row.status === 1" style="color: #fe781d;">待审核</span>
        <span v-if="row.status === 2" style="color: #ff0000;">未通过</span>
        <span v-if="row.status === 3" style="color: #1890ff;">已通过</span>
      </template>
      <template slot-scope="{ row }" slot="edit">
        <span style="color: #1890ff;cursor: pointer;">删除</span>
      </template>
    </Table>
  </div>
</template>
<script>
import expandRow from "./table-expand.vue";
export default {
  components: { expandRow },
  data() {
    return {
      columns10: [
        {
          title: "企业名称",
          slot: "name"
        },
        {
          title: "供需类型",
          slot: "type"
        },
        {
          title: "供需内容",
          slot: "content"
        },
        {
          title: "发布时间",
          slot: "time"
        },
        {
          title: "跟进状态",
          slot: "status"
        },
        {
          title: "操作",
          width: 70,
          slot: "edit"
        },
        {
          type: "expand",
          slot: "expand",
          width: 50,
          render: (h, params) => {
            return h(expandRow, {
              props: {
                row: params.row
              }
            });
          }
        }
      ],
      data9: [
        {
          name: "上海永动力有限公司",
          type: "发电机",
          content: "提供大功率的发电机",
          time: "2020-1-20",
          status: 0,
          edit: "操作",
          age: 18,
          address: "New York No. 1 Lake Park",
          job: "Data engineer",
          interest: "badminton",
          birthday: "1991-05-14",
          book: "Steve Jobs",
          movie: "The Prestige",
          music: "I Cry"
        }
      ]
    };
  }
};
</script>


<style scoped lang="scss">
.new-box {
  min-width: 1000px;
  min-height: 500px;
  padding: 30px;
}
</style> 
